import React from 'react';
import classNames from 'classnames';
import InlineIcon from '../../../../../ui-components/inline-icon/inline-icon';
import LinkCopiedIcon from '../../../../../../icons/compiled/components/LinkCopiedIcon';
import styles from './styles.scss';
const LinkCopied = _ref => {
  let {
    dataHook,
    shouldShowLink,
    text,
    isRTL
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['link-container'], {
      [styles['link-fade-in']]: shouldShowLink
    }),
    "aria-hidden": "true",
    tabIndex: "-1",
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(InlineIcon, {
    className: classNames(styles.icon, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    }),
    icon: /*#__PURE__*/React.createElement(LinkCopiedIcon, null)
  }), /*#__PURE__*/React.createElement("div", {
    "data-hook": "link-copied-text"
  }, text));
};
export default LinkCopied;
//# sourceMappingURL=link-copied.js.map